import * as R from 'ramda'
import { UserAccess } from './index'

export type InitialState = { users: UserAccess[] }
export type ACTIONTYPE =
  | { type: 'add_permission'; payload: number }
  | { type: 'remove_permission'; payload: number }
  | { type: 'assign_permission_to_all_user'; payload: boolean }

export function reducer(state: InitialState, action: ACTIONTYPE) {
  switch (action.type) {
    case 'add_permission':
      return {
        users: _updateHasPermissionStatus(state, action.payload, true),
      }
    case 'remove_permission':
      return {
        users: _updateHasPermissionStatus(state, action.payload, false),
      }
    case 'assign_permission_to_all_user':
      return {
        users: state.users.map((user) => {
          return { ...user, has_permission: action.payload }
        }),
      }
    default:
      throw new Error()
  }
}

function _updateHasPermissionStatus(
  state: InitialState,
  userId: number,
  value: boolean
): UserAccess[] {
  const userIndex = _findUserIndex(userId, state.users)
  const users = R.assocPath([userIndex, 'has_permission'], value, state.users)
  return users
}

function _findUserIndex(userId: number, users: UserAccess[]): number {
  const index = users.findIndex((i) => i.user_id === userId)
  return index
}



// WEBPACK FOOTER //
// ./src/components/SurveyAccessFormModal/reducer.tsx